<template>
  <div class="text-end">
    Copyright &copy; 2023 oDo Library / Marutech, Inc. / KAMé Music
  </div>
</template>
